(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initVocForms(root) {
      var forms = root.querySelectorAll('form[id^="VocEmailForm"], form[id^="VocWhatsappForm"]');

      forms.forEach(function (form) {
        if (form.dataset.vocBound === 'true') return;
        form.dataset.vocBound = 'true';

        // Consent-Checkbox schaltet den WhatsApp-Button erst frei
        var consentBox = form.querySelector('[data-voc-consent]');
        var submitBtn = form.querySelector('[data-voc-submit]');
        if (consentBox && submitBtn) {
          submitBtn.disabled = !consentBox.checked;
          consentBox.addEventListener('change', function () {
            submitBtn.disabled = !consentBox.checked;
          });
        }

        form.addEventListener('submit', function (event) {
          event.preventDefault();

          var submit = form.querySelector('button[type="submit"]');
          if (submit) submit.disabled = true;

          var formData = new FormData(form);
          var blockWrapper = form.closest('[data-voc-block]');
          var blockId = blockWrapper ? blockWrapper.id : null;

          fetch(form.action, {
            method: 'POST',
            body: formData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          })
            .then(function (response) { return response.text(); })
            .then(function (html) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');
              var newBlock = blockId ? doc.getElementById(blockId) : null;

              if (newBlock && blockWrapper) {
                blockWrapper.innerHTML = newBlock.innerHTML;
                initVocForms(blockWrapper); // neue Formular-Elemente erneut binden
              } else if (blockWrapper) {
                // Fallback: falls Parsing fehlschlägt, normal absenden
                form.submit();
              }
            })
            .catch(function () {
              // Netzwerkfehler: normaler Seiten-Submit als Fallback
              form.submit();
            });
        });
      });
    }

    document.querySelectorAll('[data-velion-opening-soon]').forEach(function (root) {
      initVocForms(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
